import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../../components/layout/Header';
import AdvancedSearch from '../../../components/leads/AdvancedSearch';
import LeadTable from '../../../components/leads/LeadTable';
import useLeads from '../../../hooks/useLeads';
import { useAuth } from '../../../context/AuthContext';
import { Plus } from 'lucide-react';
import { Button } from '../../../components/common/Common';

const TodayLeads = () => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();

  const today = useMemo(() => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }, []);

  const { leads, loading, pagination, filters, setFilters, onSearch, onPageChange, refresh, exportAll } = useLeads({
    created_from: `${today} 00:00:00`,
    created_to: `${today} 23:59:59`,
  });

  return (
    <div>
      <Header
        title="Today's Leads"
        subtitle={`${pagination.total || 0} leads created today`}
        actions={hasPermission('leads.add') ? <Button variant="gold" icon={Plus} onClick={() => navigate('/leads/add')}>Add Lead</Button> : null}
      />
      <div className="page">
        <AdvancedSearch filters={filters} setFilters={setFilters} onSearch={onSearch} />
        <LeadTable
          leads={leads}
          loading={loading}
          pagination={pagination}
          onPageChange={onPageChange}
          onRefresh={refresh}
          onExportAll={exportAll}
          emptyMessage="No leads created today"
        />
      </div>
    </div>
  );
};

export default TodayLeads;
